module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs-allocation-components/wbs-allocation-components.component.css
// module id = ./src/app/wbs-allocation-components/wbs-allocation-components.component.css
// module chunks = main